module.exports = __webpack_public_path__ + "img/icon_main_12_b.1fa0479d.svg";